import request from "./request";

// 登录
export const loginIn = async ({
  email,
  password
}) => {
  let ip = '';

  try {
    // ip = await getLocalIP();
    // try {
    //   const ipJSON = await fetch('https://api.ipifya.org?format=json');
    //   ipRes = await ipJSON.json();

    // }catch(error){}

    const res = await request({
      method: 'post',
      url: '/user/operator/login',
      data: {
        email,
        password,
        // ip
      }
      // ip: ipRes.ip
      // },
      // headers: {
      //   'Content-Type': 'application/x-www-form-urlencoded',
      //   'X-Real-IP': '112.112.0.1'
      // }
    });

    return res || ''
  } catch (err) { }
};

// 获取忘记密码验证码
export const getForgotPasswordEmailCode = async ({
  email
}) => {
  const res = await request({
    url: '/user/get_verify_code_by_email',
    method: 'post',
    data: {
      email
    }
  });

  return res;
};

// 忘记密码
export const forgotPasswordReset = async ({
  email,
  password,
  code
}) => {
  const res = await request({
    url: '/user/reset/operator/password',
    method: 'post',
    data: {
      email,
      password,
      verify_code: code
    }
  });

  return res;
};
